"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var web_utils_1 = require("@ubeeqo/web-utils");
var lodash_1 = require("lodash");
function snakeCaseKeys(param, methodName) {
    var snakeCaseObject = lodash_1.mapKeys(param, function (_value, key) { return lodash_1.snakeCase(key); });
    var message = "Payload keys for " + methodName + " were transformed into snake_case";
    web_utils_1.logger.message(message, web_utils_1.LOG_TYPE.info);
    return snakeCaseObject;
}
exports.snakeCaseKeys = snakeCaseKeys;
function camelCaseKeys(param, methodName) {
    var camelCasedObject = lodash_1.mapKeys(param, function (_value, key) { return lodash_1.camelCase(key); });
    var message = "Payload keys for " + methodName + " were transformed into camelCase";
    web_utils_1.logger.message(message, web_utils_1.LOG_TYPE.info);
    return camelCasedObject;
}
exports.camelCaseKeys = camelCaseKeys;
